import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'
import toast from 'react-hot-toast'

interface UpdateAssignmentsParams {
  account_manager_user_id?: string | null
  sale_rep_id?: string | null
}

const updateOrganizationAssignments = async (
  orgId: string,
  params: UpdateAssignmentsParams
) => {
  const payload: any = {}

  // Only include fields that are being updated
  if (params.account_manager_user_id !== undefined) {
    payload.account_manager_user_id = params.account_manager_user_id
  }

  if (params.sale_rep_id !== undefined) {
    payload.sale_rep_id = params.sale_rep_id
  }

  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/assignments`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(payload),
    }
  )

  response = handleErrors(response)
  const json = await response.json()
  return json.data
}

const useUpdateOrganizationAssignments = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({
      orgId,
      assignments,
    }: {
      orgId: string
      assignments: UpdateAssignmentsParams
    }) => {
      return updateOrganizationAssignments(orgId, assignments)
    },
    {
      onSuccess: (data, variables) => {
        toast.success('Assignments updated successfully!')

        // Invalidate related queries
        queryClient.invalidateQueries([organizationsKeys.all, 'missing-info'])
        queryClient.invalidateQueries(organizationsKeys.detail(variables.orgId))
        queryClient.invalidateQueries(organizationsKeys.all)
      },
      onError: (error: any) => {
        console.error('Error updating assignments:', error)
        toast.error('Failed to update assignments. Please try again.')
      },
    }
  )
}

export default useUpdateOrganizationAssignments
